import React from 'react';

import { Container } from './styles';

import { LineProps } from './interface';

const GridLine: React.FC<LineProps> = ({
  children,
  stick,
  className,
  ...props
}) => {
  return (
    <Container stick={stick} className={className} {...props}>
      <>{children}</>
    </Container>
  );
};

export default GridLine;
